import { Record } from "immutable";
import { PromptSuggestion } from "models/interfaces/conversations/prompt-suggestions/prompt-suggestion";

const defaultValues: PromptSuggestion = {
    value: "",
    label: "",
};

export default class PromptSuggestionRecord
    extends Record(defaultValues)
    implements PromptSuggestion
{
    // -----------------------------------------------------------------------------------------
    // #region Constructor
    // -----------------------------------------------------------------------------------------

    constructor(params?: Partial<PromptSuggestion>) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        super(params as Partial<PromptSuggestion>);
    }

    // #endregion Constructor

    // -----------------------------------------------------------------------------------------
    // #region Public Methods
    // -----------------------------------------------------------------------------------------

    /**
     * Merges new values into the record and returns a new instance.
     *
     * @param {RawMessagePart} values
     */
    public with(values: Partial<PromptSuggestion>): PromptSuggestionRecord {
        return new PromptSuggestionRecord(Object.assign(this.toJS(), values));
    }

    // #endregion Public Methods
}
